module.exports = __webpack_public_path__ + "img/142.5.5064c53f.png";